import { type FileContent } from './services/file-storage';

export const truncateMiddle = (text: string, maxLength: number): string => {
  if (text.length <= maxLength) return text;
  const ellipsis = '…';
  const charsToShow = maxLength - ellipsis.length;
  const frontChars = Math.ceil(charsToShow / 2);
  const backChars = Math.floor(charsToShow / 2);
  return text.slice(0, frontChars) + ellipsis + text.slice(-backChars);
};

export const isImageMimeType = (mimeType: string): boolean => {
  return mimeType.startsWith('image/');
};

export const createFile = ({
  content,
  name,
  mimeType = 'application/octet-stream',
}: {
  content: FileContent;
  name: string;
  mimeType: string;
}): File => {
  if (content instanceof Blob) {
    return new File([content], name, { type: content.type ?? mimeType });
  }

  // ArrayBuffer
  return new File([new Uint8Array(content)], name, { type: mimeType });
};
